<template>
  <div>
    <v-divider class="mt-1" :color="theme.orders_divider_color" />
    <v-layout
      row
      mt-2
      mb-1
    >
      <v-flex xs12>
        <span :style="nameStyle">{{ $t('apply_promo_code_optional') }}</span>
      </v-flex>
    </v-layout>
    <form
      @submit.prevent="applyCode"
      @keydown="form.onKeydown($event)"
      style="margin-bottom: 20px;"
    >
      <v-layout
        row
        mb-2
      >
        <v-flex
          xs8
          sm6
          md4
          lg3
          xl2
        >
          <v-text-field
            v-model="form.code"
            name="code"
            class="input-code"
            :label="$t('promo_code')"
            single-line
            hide-details
            @input="codeChange"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn
            type="submit"
            dark
            small
            :color="theme.btn_color_secondary"
          >
            {{ $t('apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'

export default {
  data: () => ({
    form: new Form({
      code: ''
    }),
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'posType'
    ]),
    ...mapGetters('promo', [
      'activePromo', 'promoMsg'
    ]),
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    }
  },
  methods: {
    codeChange () {
      this.form.code = this.form.code.toUpperCase().replace(/\s/g, '')
    },
    async applyCode () {
      if (!this.form.code) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Failed to activate promo',
          text: 'Please key in the promo code.',
          modal: true
        })
        return
      }
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('promo/fetchActivePromo', this.form.code)
      if (this.promoMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Failed to activate promo',
          text: this.promoMsg,
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return
      }
      if (this.posType === 0) {
        await this.$store.dispatch('order/checkOrder')
      } else {
        await this.$store.dispatch('order/calculateOrder')
      }
      this.form.code = ''
      this.$bus.$emit('showFullLoading', false)
      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('successfully_applied_promo'),
        noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
      })
    }
  }
}
</script>

<style scoped>
.input-code {
  padding: 0 0 0 5px;
  border: 1px solid gray;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/UsePromoCode.vue